import DefaultPopover from "./default-popover";
import WhitePopover from "./white-popover";
import ChatbotPopover from "./chatbot-popover";
import DefaultPopconfirm from "./default-popconfirm";

export default {
  DefaultPopover,
  WhitePopover,
  ChatbotPopover,
  DefaultPopconfirm,
};
